import { ListItem, Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { ISidebarProps } from '../Sidebar';

interface INestedSidebarItem extends ISidebarProps {
  label: any;
  path: string;
}

const NestedSidebarItem = ({ label, path, isNavOpen, onNavClose }: INestedSidebarItem) => {
  const { t } = useTranslation(['common']);

  return (
    <ListItem>
      <Box
        as={NavLink}
        to={path}
        display="flex"
        py="3"
        px="3"
        pl={isNavOpen ? '10' : '3'}
        alignItems="center"
        _hover={{ bg: 'rgba(255,255,255, 0.2)', cursor: 'pointer', textDecoration: 'none' }}
        sx={{ '&.active': { bg: 'rgba(255,255,255, 0.2)', cursor: 'pointer' } }}
        borderRadius="2px"
        onClick={onNavClose}
      >
        <Text>{t(label)}</Text>
      </Box>
    </ListItem>
  );
};

export default NestedSidebarItem;
